<template>
  <v-layout column fill-height fill-width>
    <v-dialog
      v-model="dialogloading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
      >
        <v-card-text class="white--text">
          Downloading PDF...
          <v-progress-linear
            v-model="valueDeterminate"
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">

      <v-card>

        <v-toolbar color="primary">
          <v-btn icon @click.native="dialog = false">
            <v-icon class="white--text">close</v-icon>
          </v-btn>
          <v-toolbar-title class="white--text">{{openedfilename}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn flat @click.native="dialog = false" class="white--text">Close</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <vue-pdf-viewer :url='pdfurl' style="height: 90vh;">
        </vue-pdf-viewer>
      </v-card>
    </v-dialog>


    <v-card>

      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>View PDFS</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>

      </v-toolbar>

      <v-data-table :headers="headers" :items="data" :search="search">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.filename }}</td>
          <td>{{ props.item.ctime | moment("MM-DD-YY")}}</td>
          <td>
            <v-btn @click="openPDF(props.item.filename)">Open</v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>


  </v-layout>
</template>

<script>
  import VuePDFViewer from 'vue-instant-pdf-viewer'

  const toLower = text => {
    return text.toString().toLowerCase()
  }

  const searchByName = (items, term) => {
    if (term) {
      return items.filter(item => toLower(item.filename).includes(toLower(term)))
    }
    return items
  }

  export default {
    name: 'TableSearch',
    data: () => ({
      openedfilename: null,
      dialog: false,
      dialogloading: false,
      valueDeterminate: 0,
      pdfurl: 'https://bitcoin.org/bitcoin.pdf',
      search: '',
      headers: [{
        text: 'Job PDF Name',
        align: 'left',
        sortable: true,
        value: 'filename'
      },
        {
          text: 'Time',
          value: 'ctime'
        },
        {
          text: 'Open',
          value: ''
        }
      ],
      data: [],
      showSnackbar: false,
      duration: 4000,
      snackMessage: '',
      resultsPerPage: 10000,
      currentPage: 0,
      totalPages: null
    }),
    methods: {
      newUser() {
        window.alert('Noop')
      },
      searchOnTable() {
        this.searched = searchByName(this.users, this.search)
      },
      updateProgressBarValue(value) {
        this.valueDeterminate = value
      },
      openPDF(name) {
        this.openedfilename = name
        this.dialogloading = true
        this.valueDeterminate = 0

        this.$http.get('/panel/review/' + name, {
          responseType: 'arraybuffer',
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          },
          onDownloadProgress: function (progressEvent) {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            this.updateProgressBarValue(percentCompleted)
          }.bind(this)
        })
          .then(response => {
            // Create a Blob from the PDF Stream

            const file = new Blob(
              [response.data], {
                type: 'application/pdf'
              })
            // Build a URL from the file

            const fileURL = window.URL.createObjectURL(file)
            // Open the URL on new Window
            this.pdfurl = fileURL
            this.dialogloading = false
            this.dialog = true
          })
          .catch(e => {
            console.log(e)
            this.showSnackbar = true
            this.snackMessage = 'Error getting pdf list!'
            this.dialogloading = false
          })
      },
      loadReviewList() {
        this.$http.get('/panel/review/' + this.resultsPerPage + '/' + this.currentPage, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        })
          .then(response => {
            this.data = response.data.data
            this.searched = response.data.data
            this.totalPages = response.data.tpage
            this.currentPage = response.data.cpage
          })
          .catch(e => {
            this.showSnackbar = true
            this.snackMessage = 'Error getting pdf list!'
          })
      }
    },
    created() {
      this.searched = this.users
    },
    mounted() {
      console.log('REVIEW MOUNTED')
      this.loadReviewList()
    },
    components: {
      'vue-pdf-viewer': VuePDFViewer
    }

  }
</script>

<style lang="scss" scoped>
  .md-field {
    max-width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Review.vue